import { Document, DocumentKkb } from "../../../types/documents.type";

export const getClientSign = (document: DocumentKkb | Document | null) => {
  return (
    document?.sign_file?.find((sign) => {
      return sign?.user?.type === "client";
    }) || null
  );
};
